import React from 'react';
import { AssuranceIcon } from 'images/index';
import { Grid, Box } from '@material-ui/core';
import { sanlamGrey3 } from 'Material-UI/colors';
import {
  ItemsWrapper,
  ContentWrapper,
  StyledChevronRight,
  StyledIcon,
  StyledGrid,
} from 'components/ChevronCardButton/styles';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { isReverse } from 'helpers/intl';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { useIntl } from 'react-intl';

export interface ChevronCardButtonPropsType {
  item: any;
  backgroundColor?: string;
  borderColor?: string;
  clickHandler: Function;
  borderRadius?: string;
  index?: any;
  deleteHoverBorder?: Boolean;
}

const ChevronCardButton = ({
  item,
  backgroundColor,
  borderColor,
  clickHandler,
  borderRadius,
  index,
  deleteHoverBorder,
}: ChevronCardButtonPropsType) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const { formatMessage } = useIntl();

  return (
    <GaClickHOC category={item.category} label={item.label}>
      <ItemsWrapper
        backgroundColor={backgroundColor}
        borderColor={borderColor}
        data-testid={index >= 0 ? `card_item_${index}` : 'card_item'}
        onClick={clickHandler}
        borderRadius={borderRadius}
        deleteHoverBorder={deleteHoverBorder}
      >
        {item.isNew && (
          <span
            style={{
              fontSize: 10,
              position: 'absolute',
              color: 'white',
              fontFamily: 'Roboto',
              paddingRight: 8,
              paddingLeft: 8,
              backgroundColor: '#F9AA01',
              boxSizing: 'border-box',
              right: 0,
              borderTopRightRadius: '10px',
              borderBottomLeftRadius: '5px',
            }}
          >
            {formatMessage({ id: 'menu.item.new' })}
          </span>
        )}
        <ContentWrapper
          alignItems="center"
          justify="space-between"
          spacing={1}
          container
        >
          {item.icon && (
            <StyledGrid xs={2} sm={1} item>
              <StyledIcon src={AssuranceIcon[item.icon]} alt="" />
            </StyledGrid>
          )}
          <Grid xs={9} sm={10} item>
            <Box ml={item.isFaq ? 0 : 1.5}>{item.title || item}</Box>
          </Grid>
          <Grid xs={1} item>
            <StyledChevronRight color={sanlamGrey3} reverse={reverse} />
          </Grid>
        </ContentWrapper>
      </ItemsWrapper>
    </GaClickHOC>
  );
};

export default ChevronCardButton;
